module.exports = __webpack_public_path__ + "static/media/FRONT-BNB.0ebd6e18.svg";